import { extendTheme } from '@chakra-ui/react'

export default extendTheme({
    colors: {
        transparent: 'transparent',
        black: '#000',
        white: '#dadada',
        grey: '#6D5168'
    }
});